import React from 'react';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { Text } from '@components/Text/Text.component';
import { CircleChevronDownIcon } from '@icons/CircleChevronDown.icon';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';
import styles from './MoreMetricsButton.module.scss';

interface props {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  disabled: boolean;
}
const MoreMetricsButton = ({ onClick, disabled }: props) => {
  return (
    <div className={classnames(styles.container, disabled ? styles.disabled : '')}>
      <IconButton className={styles.button} onClick={onClick} type="button">
        <Text className={styles.span} i18nKey="meteo.display-more-metrics" tag="span" variant="small" />
        <CircleChevronDownIcon className={styles.span} fillColor={PlcColor.GREEN} height={20} width={20} />
      </IconButton>
    </div>
  );
};

export { MoreMetricsButton };
